import * as orderActionsLogService from 'services/orderActionLogService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { GetOrderActionsLogRequest } from 'services/dtoModels/orderActionLog/getOrderActionsLogRequest';
import type { SWRResponse } from 'swr';

type SWROrderActionsLogData = Awaited<
  ReturnType<typeof orderActionsLogService.getOrderActionsLogAsync>
>;

const useOrderActionsLog = (
  params?: GetOrderActionsLogRequest,
  load = true
): SWRResponse<SWROrderActionsLogData, AxiosError> =>
  useSWR(
    load ? [SWR_ORDER_ACTIONS_LOG_ENDPOINT, params] : null,
    async ([_, params]) =>
      await orderActionsLogService.getOrderActionsLogAsync(params ?? {})
  );

export const SWR_ORDER_ACTIONS_LOG_ENDPOINT = 'order-actions-log';
export default useOrderActionsLog;
